<template>
  <picture :id="'responsive-image-component-'+id" v-lazyload="lazyLoad"
          class="responsive-image-wrapper tourdata-image"
          :style="pictureStyle" :ref="'ric-'+id">
    <source v-for="(breakpoint, viewport) in breakpoints" v-if="getImgUrlByViewport( viewport )"
            :media="constructMediaQuery( viewport )"
            :data-srcset="constructSrcSet( viewport )"/>
    <img class="img-responsive" :data-src="src" :class="imgClass" :title="title" :alt="alt" :style="imgStyle"/>
  </picture>
</template>
<style></style>
<script>
export default {
  name: "responsive-image",
  props: {
    src: String,
    srcXs: String,
    srcSm: String,
    srcMd: String,
    srcLg: String,
    srcXl: String,
    aspectRatio: {type: String, default: false},
    lazyLoad: {type: Boolean, default: true},
    alt: String,
    title: String,
    imgClass: String,
    placeholder: String,
    debug: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      height: null,
      width: null,
      currentViewport: null,
      breakpoints: {
        xl: 1600,
        lg: 1200,
        md: 992,
        sm: 768,
        xs: 0
      }
    }
  },
  methods: {
    getImgUrlByViewport: function( viewport ){
      var srcKey = 'src' + viewport.charAt(0).toUpperCase() + viewport.slice(1);
      if(this.$props[srcKey]){
        return this.$props[srcKey];
      }
      return false;
    },
    constructMediaQuery: function ( viewport ) {
      let width = this.breakpoints[viewport];
      if(width === 0) return null;
      return '(min-width: '+ width +'px)'
    },
    constructSrcSet: function( viewport ){
      return this.getImgUrlByViewport( viewport )+' 1x';
    },
    determineViewport: function() {
      var w = window.innerWidth;
      for (const [key, value] of Object.entries(this.breakpoints)) {
        if(w >= value){
          this.currentViewport = key;
          return key
        }
      }
    },
    determineSize: function() {
      this.width = this.$el.clientWidth;
      var ratio = eval(this.aspectRatio);
      this.height = Math.round(this.width / ratio);
      if(this.debug)console.log({msg:'Determined size:', width: this.width, height:this.height})
    },
    determineAspectRatio: function() {
      if(this.fixedAspectRatio){
        this.aspectRatio = this.fixedAspectRatio;
      }
    },
    determineFallback: function() {
      if(!this.src){
        for (const [key, value] of Object.entries(this.breakpoints)){
          var srcKey = 'src' + key.charAt(0).toUpperCase() + key.slice(1);
          if(this.$props[srcKey]){
            return this.src = this.$props[srcKey];
          }
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.determineFallback();
      this.determineAspectRatio();
      this.determineViewport();
      //this.determineSize();
    })
  },
  watch: {
    currentViewport: function(newVal, oldVal) {
      if(newVal != oldVal){

      }
    }
  },
  created() {
    window.addEventListener("resize", this.determineViewport);
  },
  destroyed() {
    window.removeEventListener("resize", this.determineViewport);
  },
  computed: {
    pictureStyle:function(){
      if(this.aspectRatio){
        return 'aspect-ratio:'+this.aspectRatio+';overflow:hidden;';
      }
      return ''
    },
    imgStyle: function(){
      return '';
    }
  }
}
</script>
